import {
  Box,
  Container,
  Pagination,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PageHeader from "./components/PageHeader";
import NavigationBox from "../utils/NavigationBox";
import SubjectCard from "./components/SubjectCard";
import axios from "axios";
import LoadingComponent from "../utils/LoadingComponent";
import { useTranslation } from "react-i18next";

const CompletedExams = () => {
  const [loading, setLoading] = useState(true);
  const [exams, setExams] = useState([]);
  const [examsFull, setExamsFull] = useState({});
  const { t } = useTranslation();
  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/exam/completed-exams?page=${page}`)
      .then((res) => {
        setExams(res?.data?.data?.data);
        setExamsFull(res?.data?.data)
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [page]);

  return (
    <Box>
      <PageHeader />
      <Box sx={{ background: "#fff", padding: "50px 0" }}>
        <Container maxWidth="lg">
          <Stack
            direction={"row"}
            sx={{ gap: "20px", flexWrap: { xs: "wrap", sm: "initial" } }}
          >
            <NavigationBox />
            {loading ? (
              <Box sx={{ marginInlineStart: "100px" }}>
                <LoadingComponent />
              </Box>
            ) : (
              <Box sx={{width: '100%'}}>
                <Stack direction={"row"} sx={{ gap: "30px", flexWrap: "wrap" }}>
                  {exams?.length == 0 ? (
                    <Typography variant="h5" color={"GrayText"}>
                      {t("no_exams")}
                    </Typography>
                  ) : (
                    exams?.map((e, i) => <SubjectCard key={i} i={i} data={e} />)
                  )}
                </Stack>
                {exams?.length > 0 && <Pagination count={Math.ceil(examsFull?.total/examsFull?.per_page)} page={page} onChange={handleChange} color="primary" sx={{display: 'grid', placeItems: 'center', marginTop: '30px'}}/>}
              </Box>
            )}
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default CompletedExams;
